// extracted by mini-css-extract-plugin
var _1 = "WQQdw__entry";
var _2 = "WQQdw__verification";
export { _1 as "entry", _2 as "verification" }
